/** Instrument Commission helpers — maps API payloads for the Instruments Commission page. */

const toList = (payload) => {
  if (Array.isArray(payload)) return payload.filter(Boolean);
  if (Array.isArray(payload?.result)) return payload.result.filter(Boolean);
  if (Array.isArray(payload?.data)) return payload.data.filter(Boolean);
  if (Array.isArray(payload?.items)) return payload.items.filter(Boolean);
  return [];
};

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const classifyGroup = (name = '') => {
  const n = String(name).toLowerCase();
  if (n.includes('ultra')) return 'ultra';
  return 'standard';
};

/** Fallback tiers when partner levels API is empty */
export const FALLBACK_TIERS = [
  { id: 't1', name: 'Tier 1', levelNumber: 1 },
  { id: 't2', name: 'Tier 2', levelNumber: 2 },
  { id: 't3', name: 'Tier 3', levelNumber: 3 },
  { id: 't4', name: 'Tier 4', levelNumber: 4 },
  { id: 't5', name: 'Tier 5', levelNumber: 5 },
];

export const mapPartnerTiersToTabs = (tiers = []) => {
  if (!tiers.length) return FALLBACK_TIERS;
  return tiers.map((t, index) => ({
    id: t.id ?? t.affiliateLevelId ?? `tier-${index + 1}`,
    name: t.name || t.levelName || `Tier ${index + 1}`,
    levelNumber: t.levelNumber ?? index + 1,
    affiliateLevelId: toNum(t.id ?? t.affiliateLevelId ?? t.levelNumber ?? index + 1),
  }));
};

/**
 * Map GetInstrumentCommissions API result into UI groups.
 * Expected group shape:
 * { instrumentGroupId, groupName, instruments: [{ instrumentName/Value, commissionAmount }] }
 */
export const mapInstrumentCommissionGroups = (payload) => {
  const list = toList(payload);

  return list
    .map((group, index) => {
      const instruments = toList(
        group.instruments ?? group.Instruments ?? group.pairs ?? group.items
      );
      const pairs = instruments
        .map((row, i) => {
          const symbol =
            row.instrumentValue ||
            row.InstrumentValue ||
            row.instrumentName ||
            row.InstrumentName ||
            row.symbol ||
            row.Symbol ||
            row.name ||
            '';
          if (!symbol) return null;
          return {
            id: row.instrumentId ?? row.InstrumentId ?? `${symbol}-${i}`,
            symbol: String(symbol),
            rate: toNum(
              row.commissionAmount ??
                row.CommissionAmount ??
                row.commission ??
                row.rate ??
                row.Rate
            ),
          };
        })
        .filter(Boolean);

      const name = group.groupName || group.GroupName || group.name || `Group ${index + 1}`;
      const id = String(group.instrumentGroupId ?? group.InstrumentGroupId ?? group.id ?? `group-${index + 1}`);

      return {
        id,
        name: String(name),
        kind: classifyGroup(name),
        pairs,
      };
    })
    .filter((g) => g.pairs.length > 0 || g.name);
};

/** Kept for backward compatibility — prefer API mapping. */
export const buildForexGroupsForTier = () => [];
